import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import DropLetter from "components/layout/dropLetter/DropLetter";
import React from "react";
import BoardMembers from "./BoardMembers";

function TrusteesPage() {
  return (
    <PageLayout>
      <DefaultCard title="TRUSTEES">
        <Typography variant="body1" lineHeight={1.8}>
          <DropLetter letter="T" />
          he affairs of Harmony Hill are managed by a Board of Trustees. The
          Board meets twice a year in the spring and fall. According to the
          by-laws of Harmony Hill, all decisions made by the Board are
          unanimous.
        </Typography>
        <BoardMembers />
      </DefaultCard>
    </PageLayout>
  );
}

export default TrusteesPage;
